import {
  CommunicationChannel,
  CommunicationTemplateStatus,
} from "@mimber/schema"

export const CHANNEL_OPTIONS = [
  { label: "Email", value: CommunicationChannel.EMAIL },
  {
    label: "SMS (coming soon)",
    value: CommunicationChannel.SMS,
    disabled: true,
  },
  {
    label: "Push Notification (coming soon)",
    value: CommunicationChannel.PUSH,
    disabled: true,
  },
]

export const STATUS_OPTIONS = [
  { label: "Draft", value: CommunicationTemplateStatus.DRAFT },
  { label: "Active", value: CommunicationTemplateStatus.ACTIVE },
  { label: "Archived", value: CommunicationTemplateStatus.ARCHIVED },
]
